import { render, staticRenderFns } from "./koiRaffleDetails.vue?vue&type=template&id=66f61310&scoped=true"
import script from "./koiRaffleDetails.vue?vue&type=script&lang=ts"
export * from "./koiRaffleDetails.vue?vue&type=script&lang=ts"
import style0 from "./koiRaffleDetails.vue?vue&type=style&index=0&id=66f61310&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f61310",
  null
  
)

export default component.exports